export const HAULIERS = {
  DPMP: 'dpmp',
  NITRA: 'nitra',
  TRENCIN: 'trencin',
  RUZOMBEROK: 'ruzomberok',
  DPB: 'dpb',
  POLAND: 'poland',
  VISEUDESUS: 'viseudesus',
  DPMO: 'dpmo',
  DPMLB: 'dpmlb',
  JIKORD: 'jikord',
  LOCAL: 'local',
  DPMDAS: 'dpmdas',
  DPMPR: 'dpmpr',
  ADOSA: 'adosa',
};

export const TABLE_TAB_FILTER_STYLES = 'margin-top: -57px; margin-right: -15px;';

export const LEFT_MENU_TAB_INDEX = 100;

export const DEFAULT_COOLDOWN_DAYS = 30;
